export default "__VITE_ASSET__81acc670__"